/**
 * The one tier badge for the policy module.
 *
 * Every policy tier on every policy screen renders through this component, so
 * there is a single place where a tier can be labelled or mis-labelled. It can
 * never render an empty pill: `tierLabel` returns words for every input,
 * including null, undefined and values this build has never heard of, and the
 * colours are inline so the app-wide dark theme cannot repaint the text to
 * match the pill (which is exactly how the white tier went blank).
 */

import React from "react";
import { TIER_BADGE_CLASS, tierLabel, tierBadgeStyle, isKnownTier } from "./policyVocab";

export default function TierBadge({ tier, testId }) {
  const label = tierLabel(tier);
  const known = isKnownTier(tier);
  return (
    <span
      className={TIER_BADGE_CLASS}
      style={tierBadgeStyle(tier)}
      data-testid={testId}
      data-tier={typeof tier === "string" ? tier : ""}
      data-tier-known={known ? "yes" : "no"}
      title={known ? undefined : "This tier value is not one the page recognises"}
    >
      {label}
    </span>
  );
}
